/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenericDropdownItem_String_String } from '../models/GenericDropdownItem_String_String';
import type { PagedResultDto_EsppPptPurchasePeriodResponseVm } from '../models/PagedResultDto_EsppPptPurchasePeriodResponseVm';
import type { Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto';
import type { Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptChangeVm } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptChangeVm';
import type { Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptEnrollVm } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptEnrollVm';
import type { Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptPurchasePeriodDetailVm } from '../models/Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptPurchasePeriodDetailVm';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EsppPptPurchasePeriodService {

    /**
     * @param showFuturePurchasePeriods
     * @param showPastPurchasePeriodsWherePptDidNotEnroll
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_EsppPptPurchasePeriodResponseVm OK
     * @throws ApiError
     */
    public static getApiAwardApiPptEsppPurchasePeriod(
        showFuturePurchasePeriods?: boolean,
        showPastPurchasePeriodsWherePptDidNotEnroll?: boolean,
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_EsppPptPurchasePeriodResponseVm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/ppt/espp/purchase-period',
            query: {
                'ShowFuturePurchasePeriods': showFuturePurchasePeriods,
                'ShowPastPurchasePeriodsWherePptDidNotEnroll': showPastPurchasePeriodsWherePptDidNotEnroll,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptPurchasePeriodDetailVm OK
     * @throws ApiError
     */
    public static getApiAwardApiPptEsppPurchasePeriod1(
        purchasePeriodId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptPurchasePeriodDetailVm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/ppt/espp/purchase-period/{purchasePeriodId}',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param offeringPeriodId
     * @returns GenericDropdownItem_String_String OK
     * @throws ApiError
     */
    public static getApiAwardApiPptEsppEnrollmentActions(
        offeringPeriodId: string,
    ): CancelablePromise<Array<GenericDropdownItem_String_String>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/ppt/espp/{offeringPeriodId}/enrollment-actions',
            path: {
                'offeringPeriodId': offeringPeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiPptEsppPurchasePeriodEnroll(
        purchasePeriodId: string,
        requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptEnrollVm,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/ppt/espp/purchase-period/{purchasePeriodId}/enroll',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiPptEsppPurchasePeriodUnenroll(
        purchasePeriodId: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/ppt/espp/purchase-period/{purchasePeriodId}/unenroll',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchasePeriodId
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiPptEsppPurchasePeriodChange(
        purchasePeriodId: string,
        requestBody?: Wealthlane_AwardService_Dtos_EsppDtos_PptSide_EsppPptChangeVm,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/ppt/espp/purchase-period/{purchasePeriodId}/change',
            path: {
                'purchasePeriodId': purchasePeriodId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param purchaseItemId
     * @returns Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiPptEsppAwardPurchaseItemAwardDetail(
        purchaseItemId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_EsppDtos_EsppPurchaseDtos_PurchaseOutputListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/ppt/espp/award/purchase-item/{purchaseItemId}/award-detail',
            path: {
                'purchaseItemId': purchaseItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
